const KEY = "taweelai_notifications";
const getNotifications = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
const addNotification = ({ type, titleAr, titleEn, bodyAr, bodyEn }) => {
  const list = getNotifications();
  const recent = list.find((n) => n.type === type && Date.now() - n.timestamp < 3e4);
  if (recent) return;
  list.unshift({
    id: `${type}_${Date.now()}`,
    type,
    titleAr,
    titleEn,
    bodyAr,
    bodyEn,
    read: false,
    timestamp: Date.now()
  });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20)));
};
const markAllRead = () => {
  const list = getNotifications().map((n) => ({ ...n, read: true }));
  localStorage.setItem(KEY, JSON.stringify(list));
};
const markOneRead = (id) => {
  const list = getNotifications().map(
    (n) => n.id === id ? { ...n, read: true } : n
  );
  localStorage.setItem(KEY, JSON.stringify(list));
};
const unreadCount = () => getNotifications().filter((n) => !n.read).length;
const clearNotifications = () => localStorage.removeItem(KEY);
export {
  addNotification,
  clearNotifications,
  getNotifications,
  markAllRead,
  markOneRead,
  unreadCount
};
